import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IConnectSourceState {
	modalIsOpened: boolean;
}

const searchParams = new URLSearchParams(window.location.search);

const initialState: IConnectSourceState = {
	modalIsOpened: searchParams.get('connectSourceModal') === 'true',
};

export const connectSourceSlice = createSlice({
	name: 'connectSource',
	initialState,
	reducers: {
		setModalIsOpened: (state, action: PayloadAction<boolean>) => {
			state.modalIsOpened = action.payload;
		},
	},
});

export default connectSourceSlice.reducer;
export const { setModalIsOpened } = connectSourceSlice.actions;
